import { SvgIcon, SvgIconProps } from '@mui/material';

export const ShippingDiscountIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 19' fill='none'>
        <g clipPath='url(#clip0_504_7230)'>
          <path
            d='M1 14.5C1.1 14.5 1.2 14.5 1.4 14.5H3.5'
            stroke='currentColor'
            strokeWidth='2.02'
            strokeLinecap='round'
          />
          <path
            d='M10.2002 14.6006H12.6002C13.5002 14.6006 14.3002 13.8006 14.3002 12.9006V1.10059'
            stroke='currentColor'
            strokeWidth='2.02'
            strokeLinecap='round'
          />
          <path
            d='M14.3999 1H19.2999C22.2999 1 24.6999 3.3 24.6999 6.1V12.9C24.6999 13.8 23.8999 14.6 22.8999 14.6H22.2999M11.8999 14.6H15.2999'
            stroke='currentColor'
            strokeWidth='2.02'
            strokeLinecap='round'
          />
          <path
            d='M6.9 18.0002C8.77777 18.0002 10.3 16.478 10.3 14.6002C10.3 12.7224 8.77777 11.2002 6.9 11.2002C5.02223 11.2002 3.5 12.7224 3.5 14.6002C3.5 16.478 5.02223 18.0002 6.9 18.0002Z'
            stroke='currentColor'
            strokeWidth='2.02'
          />
          <path
            d='M18.6998 18.0002C20.5776 18.0002 22.0998 16.478 22.0998 14.6002C22.0998 12.7224 20.5776 11.2002 18.6998 11.2002C16.822 11.2002 15.2998 12.7224 15.2998 14.6002C15.2998 16.478 16.822 18.0002 18.6998 18.0002Z'
            stroke='currentColor'
            strokeWidth='2.02'
          />
          <path d='M9.1999 1.60059L3.3999 7.40059' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
          <path
            d='M2.9001 0.200195C3.6001 0.200195 4.2001 0.800195 4.2001 1.5002C4.2001 2.2002 3.7001 2.8002 2.9001 2.8002C2.1001 2.8002 1.6001 2.2002 1.6001 1.5002C1.6001 0.800195 2.2001 0.200195 2.9001 0.200195Z'
            fill='currentColor'
          />
          <path
            d='M9.5002 6.40039C10.2002 6.40039 10.8002 7.00039 10.8002 7.70039C10.8002 8.40039 10.2002 9.00039 9.5002 9.00039C8.8002 9.00039 8.2002 8.40039 8.2002 7.70039C8.2002 7.00039 8.8002 6.40039 9.5002 6.40039Z'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_504_7230'>
            <rect width='25.7' height='18.9' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};
